const hexToRGBA = (hex: string, a: string): string => {
  if (hex.length < 7) throw new Error('Hex should be with the following format: #ffffff')

  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)

  if (a) return `rgba(${r}, ${g}, ${b}, ${a})`
  return `rgb(${r}, ${g}, ${b})`
}

export default hexToRGBA
